import Label from '@/atoms/typography/Label';
import BaseEntityType from '@enums/BaseEntityType';
import Shape from '@enums/Shape';
import Size from '@enums/Size';
import Stack from '@mui/material/Stack';
import BadgeColor from './utils/BadgeColor';
import NumberBadgeSize from './utils/NumberBadgeSize';

const NumberBadge = ({
  color = 'secondary',
  number,
  size = Size.X_SMALL,
  shape = Shape.CIRCLE,
  overrideStyles,
}) => {
  const entityType = BaseEntityType[color];
  const colors = BadgeColor[entityType || color];
  const sizeProps = NumberBadgeSize[shape][size];

  if (shape === Shape.SQUARE) {
    sizeProps.borderRadius = '2px';
  }

  return (
    <Stack
      sx={{
        ...sizeProps,
        ...colors,
        ...overrideStyles,
      }}
      justifyContent="center"
      alignItems="center"
    >
      <Label
        overrideStyles={{
          color: colors.color,
          fontSize: sizeProps.fontSize,
          fontWeight: sizeProps.fontWeight,
        }}
      >
        {number}
      </Label>
    </Stack>
  );
};

export default NumberBadge;
